export const isAppOnLatestVersion = async (): Promise<boolean> => {
  // Get latest available version of the current environment
  return await fetch("/config.json", { cache: "no-store" })
    .then((res) => res.json())
    .then((config) => {
      const key = "AOP_VERSION";
      const parsedCurrentVersion = parseVersion(window[key]);
      const parsedLatestVersion = parseVersion(config[key]);

      if (parsedCurrentVersion === undefined || parsedLatestVersion === undefined) {
        return true; // If version parsing fails, assume it's up to date
      }

      return parsedCurrentVersion >= parsedLatestVersion;
    });
};

function parseVersion(version: unknown): number | undefined {
  if (!version || typeof version !== "string") {
    return undefined;
  }

  const splitVersion = version.split(".");
  if (splitVersion.length !== 3) {
    return undefined;
  }

  const [date, hash, build] = splitVersion;
  if (!date || !hash || !build) {
    return undefined;
  }

  const parsedBuild = Number(build);
  if (isNaN(parsedBuild)) {
    return undefined;
  }

  return parsedBuild;
}
